import * as actionTypes from '../action-types';
import { WatcherEntityItem } from '../../watchers.types';
import { UserWatchersActions } from '../actions';

type ReducerType = Array<string>;

const defaultState: ReducerType = [];

export function userWatchersUniqueIdsReducer(
  state: ReducerType = defaultState,
  action: UserWatchersActions,
) {
  switch (action.type) {
    case actionTypes.SET_USER_WATCHERS: {
      const { watchers } = action.payload;
      const newUniqueIds = watchers.map(
        (item: WatcherEntityItem) => item.uniqueId,
      );
      return newUniqueIds;
    }
    case actionTypes.SET_USER_WATCHER: {
      const { watcher } = action.payload;
      return state.concat([watcher.uniqueId]);
    }
    case actionTypes.UNSET_USER_WATCHER: {
      const { uniqueId } = action.payload;
      return state.filter((currentUniqueId) => currentUniqueId !== uniqueId);
    }
    default: {
      return state;
    }
  }
}
